export default __webpack_public_path__ + "static/media/Penugachiprolu.99e48db0.webp";